import React, { FC, ReactNode } from 'react'
import { Modal } from 'react-bootstrap'
import './ModalHeader.scss'

interface Props {
  children?: ReactNode
  closeButton?: boolean
  className?: string
}

export const ModalHeader: FC<Props> = props => <Modal.Header bsPrefix="modal-dialog-header" {...props} />
